<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_CONTENT_CREATORS"
    title="Content Creators"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Content Creators"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunityContentCreatorExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
      :show-filters="false"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No content creators found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no content creators available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_CONTENT_CREATORS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  useOrgCommunityContentCreatorExpertiseFeedStore,
} from "SmartFeed/stores/feed/org-community-content-creator-expertise-feed-store";

export default {
  name: "ContentCreators",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_CONTENT_CREATORS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunityContentCreatorExpertiseFeedStore },
};
</script>
